var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRightArrowWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.854,
    height: 8.561,
    viewBox: "0 0 11.854 8.561",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5546",
    "data-name": "Group 5546"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5102",
    "data-name": "Path 5102",
    d: "M82.091,125.346a.524.524,0,0,1,.741,0l3.755,3.755a.532.532,0,0,1,.036.04l.01.013.02.027.013.021.013.023c0,.008.008.016.011.024l.01.022c0,.008.006.017.009.026l.008.023c0,.009,0,.019.007.028l.005.021a.366.366,0,0,1,.006.037l0,.013a.516.516,0,0,1,0,.105v.006c0,.015,0,.03-.007.045l0,.013c0,.012-.006.025-.009.037l0,.013c0,.012-.008.024-.013.036l0,.01c-.006.012-.011.024-.017.036l0,.007c-.007.012-.014.025-.022.037l0,0a.514.514,0,0,1-.062.075L82.831,133.6a.523.523,0,0,1-.74-.74L84.954,130H75.411a.524.524,0,1,1,0-1.047h9.543l-2.863-2.863A.523.523,0,0,1,82.091,125.346Z",
    transform: "translate(-74.887 -125.192)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowWhite);
export default __webpack_public_path__ + "static/media/RightArrowWhite.e3e17055e1c3b2bdd203afe270e73e86.svg";
export { ForwardRef as ReactComponent };